
import { api } from "../api";

/**
 * departmentUpdateStatusById - Function that updates on database an existing department status by id  
 * /departments/{id}/{status}  
 * method PUT  
 * @async-function
 */
const departmentUpdateStatusById = async (token: string, id: number, status: string) => {
    const response = await api.put(
        `/departments/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default departmentUpdateStatusById;
